import Grid from "../Grid/Grid";
import styles from './ParticipantsContent.module.css'
import logo from '../../assets/les-logo.png'
import ProfileCard from "../ProfileCard/ProfileCard";

export default function ParticipantsContent() {
    const elements = Array.from({ length: 100 }, (v, k) =>
        <ProfileCard
            key={k}
            imageUrl={logo}
            name='Lorem ipsum'
            seeMore={'Ver mais'}
            withButton={true}
            withIconGit={true} />)


    return (
        <div className={styles['container']}>
            <div className={styles['title']}>PARTICIPANTES</div>


            <Grid items={elements} />
        </div>
    );
}